// routes
import { PATH_BASIC_DATA } from '../../routes/paths';

// components
import SvgIconStyle from '../../components/commonComponents/SvgIconStyle';
import i18n from '../../locales/i18n';
// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = { 
  fileImport: getIcon('activities'),
  quoteEquipment: getIcon('activities') // TODO: get cubes_add.svg (not in the folder yet)
};

const sidebarConfig = [
  {
    subheader: i18n.t("BasicData.BasicData"),
    items: [
      {
        title: i18n.t("BasicData.FileImport"),
        path: PATH_BASIC_DATA.FileImport,
        icon: ICONS.fileImport
      },
       {
        title: i18n.t("BasicData.QuoteEquipment"),
        path: PATH_BASIC_DATA.QuoteEquipment,
        icon: ICONS.quoteEquipment
       }
    ]
  }
];

export default sidebarConfig;